import React from 'react'

const Bulletine = () => {
  return (
    <div className="max-w-8xl mx-52 px-2 sm:px-6 lg:px-8 space-x-8">
      <h1 className='text-7xl'>Reports </h1></div>
  )
}

export default Bulletine